import styled from "styled-components";

export const EventType = styled.div`
display:flex;
flex-direction:column;
align-items:start;
justify-content:start;
`
export const TreggarButtons = styled.div`
width:fit-content;
height:48px;
display: inline-flex;
padding: 4px;
align-items: center;
gap: 8px;
flex-shrink: 0;
border-radius: 6px;
border: 1px solid var(--bold-filed, #E8EBF4);
background: var(--Blue-10, #F3F6F9);
`
export const ButtonItem = styled.div`
display: inline-flex;
color:${(props) => props.clicked ? "var(--Blue-100, #2555EF)" : "var(--Dark-Blue-40, #99ABBE)"} ;
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--CommunicationButtonItemFont-family);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 32px; 
cursor: pointer;
padding: 4px 12px 4px 12px;
background-color:${(props) => props.clicked ? "var(--Blue-40, #C1CEF9)" : ""} ;
border-radius: 6px;

`
export const WrapperButtons = styled.div`
width:75%;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
`
export const InputWrapper = styled.div`
    position: relative;
    width: 100px;
    display: inline-block;
`;

export const Input = styled.input`
    width: 90%;
    padding-right: 30px;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid var(--Blues-Blue-3, #99B7EF);
    border-radius: 4px;
    height: 48px;
`;

export const ArrowButton = styled.button`
    position: absolute;
    right: 19px;
    width: 20px;
    height: 15px;
    font-size: 10px;
    cursor: pointer;
    border: none;
    background: transparent;
    border-radius: 2px;
    &:first-of-type {
        top: 5px;
    }

    &:last-of-type {
        bottom: 5px;
    }

    &:hover {
        background-color: #e0e0e0;
    }
`;